<template>
    <div class="d-flex flex-wrap pt-3 lottery-page" style="
        background-size: cover; 
        background: #12101C;
        padding-bottom: 7rem;
        width: 100%;
    ">
        <div class="col-xl-12 home-cards">
            <div>
                <div class="row align-items-center pl-4 pb-4">
                    <div>
                        <h3
                            class="mb-0 page-title"
                            v-if="$store.state.language === 'en'"
                        >
                            Recent 3d history
                        </h3>
                        <h3 class="mb-0 page-title" v-else>
                            သုံးလုံးထွက်ပြီး ဂဏန်းများ
                        </h3>
                    </div>
                </div>
                <div>
                    <!-- Projects table -->
                    <table>
                        <thead>
                            <tr v-if="$store.state.language === 'en'">
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                >
                                    Date
                                </th>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                >
                                    Result
                                </th>
                            </tr>
                            <tr v-else>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                >
                                    နေ့စွဲ
                                </th>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                >
                                    ရလဒ်
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(
                                    threeDhistory, index
                                ) in threeDHistories"
                                :key="index"
                            >
                                <td scope="row" class="text-center">
                                    
                                        {{
                                            threedDrawDateFormat(
                                                threeDhistory.draw_date
                                            )
                                        }}
                                    
                                </td>
                                <td class="text-center">
                                    {{ threeDhistory.result }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="bet-container">
            <button class="btn btn-primary custom-btn py-3 text-nowrap" @click="$router.push('/user/3d')">
                    {{
                        $store.state.language === "en"
                            ? "BET"
                            : "ထိုးမည်"
                    }}    
            </button>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      twoDdata: {},
      isLive: false,
      threeDHistories: {},
      interval: null,
      threedData: {},
    };
  },
  methods: {
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDliveresult() {
      try {
        const res = await axios.get('/2d/data/live');
        this.twoDdata = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    fetchLive() {
      this.interval = setInterval(() => this.fetchTwoDliveresult(), 4000);
    },

    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const threeDres = await axios.get('/threed_history');
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  unmount() {
    clearInterval(this.interval);
  },
  mounted() {
    this.fetchThreedDdata();
    this.fetchTwoThreeDHistories();
  },
};
</script>
<style scoped>
.lottery-page {
    color: #F4F0E8;
}

.page-title {
    color: #E76229 !important;
}

.custom-btn {
    background: #E76229 !important;
    color: #fff !important;
    padding: 0 30px !important;
    box-shadow: none !important;
}

table {
        width: 100%;
        border-collapse: collapse;
        overflow: hidden;
        color: #E76229;
    }

    th,
    td {
        padding: 10px !important;
        border: none !important;
        font-weight: 400 !important;
        color: #E76229 !important;
    }

    th {
        text-align: left;
    }

    thead {
        th {
            background: #E76229 !important;
            color: #fff !important;
        }
    }

    tbody {
        color: #E76229;
        tr {
            &:hover {
                background-color: rgba(231, 98, 41, 0.16);
            }
        }
        td {
            position: relative;
            color: #E76229 !important;
            &:hover {
                &:before {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: -9999px;
                    bottom: -9999px;
                    z-index: -1;
                }
            }
        }
    }


.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 70px;
    width: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.main-image-wrapper img {
    width: 100%;
}
.video-container {
    height: 500px;
    width: 100%;
}
.notice-bar {
    margin-top: -40px;
    z-index: 1;
    font-size: 20px;
    color: #F4F0E8;
    background: rgba(231, 98, 41, 0.7);
}
.twod-threed-cards {
    height: 200px;
}
.live-number {
    font-weight: bold;
    font-size: 25px;
}
.live-result {
    font-weight: bolder;
    font-size: 60px;
    animation-name: live-number-animation;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}
.not-live-text {
    font-weight: bold;
    font-size: 24px;
}
.cards-container {
    display: flex;
    flex-wrap: wrap;
}
.card-body {
    padding: 0px !important;
}
.cards-container-mobile {
    display: none;
}
@keyframes live-number-animation {
    from {
        color: white;
    }
    to {
        color: red;
    }
}

@media (max-width: 768px) {
    .video-container {
        height: 300px;
        width: 100%;
    }
    .main-wrapper {
        padding: 7px !important;
    }
    .notice-bar {
        margin-top: 0px;
        height: 30px;
        z-index: 1;
        font-size: 13px;
        color: #F4F0E8;
        background: rgba(231, 98, 41, 0.7);
    }
    .live-number {
        font-weight: bold;
        font-size: 20px;
    }
    .live-result {
        font-weight: bolder;
        font-size: 37px;
    }

    .cards-container {
        display: none;
    }
    .cards-container-mobile {
        padding: 0px !important;
        margin-top: 15px !important;
        display: flex;
        flex-wrap: wrap;
    }
    .home-cards {
        padding-left: 10px;
        padding-right: 10px;
    }
    .card-body {
        padding: 0px !important;
    }
    .not-live-text {
        font-size: 18px;
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
